export default __webpack_public_path__ + "static/media/acceso_perfiles_ilus2.94fe92e9.svg";